// extracted by mini-css-extract-plugin
export default {"leftCell":"leftCell__JWqcD8W1FkqF"};